<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven"> </el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine">
        <div>
          <div class="title_div">
            <span class="title-span">发布日期:</span>
            <el-date-picker
              @change="xzStartChange"
              v-model="xzParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="xzEndChange"
              v-model="xzParams.createDateEnd"
              size="small"
              class="title-date2"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="xzCreatDialogVisible = true"
              >新建勋章
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="xzList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="勋章logo"
                width="200"
                align="center"
              >
                <template slot-scope="scope">
                  <el-image :src="titleUrl + scope.row.logoPath"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="medalName" label="勋章名称" align="center">
              </el-table-column>
              <el-table-column
                prop="competitionTypeName"
                label="分类"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="remarks" label="获得条件" align="center">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="发布日期"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column prop="address" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="edutXZ(scope.row.id)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="xzSizeChange"
              @current-change="xzCurrentChange"
              :current-page="xzResult.current"
              :page-size="xzResult.size"
              layout="total,prev, pager, next, sizes"
              :total="xzResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
        <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="创建勋章"
      :visible.sync="xzCreatDialogVisible"
      width="770px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">勋 章 名 称:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="xzCreatParams.medalName"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">勋 章 分 类:</span>
        <!--        <el-input size="small" class="title-select" v-model="xzCreatParams.competitionType"></el-input>-->
        <el-select
          v-model="xzCreatParams.competitionType"
          size="small"
          class="title-select"
        >
          <el-option
            v-for="item in this.xzflList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span">获 取 条 件:</span>
        <el-radio-group
          class="title-radio"
          v-model="xzCreatParams.medalType"
          @change="tjChange"
          size="small"
        >
          <el-radio-button
            v-for="item in this.xztjList"
            :label="item.value"
            :key="item.value"
            >{{ item.text }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="tiaojianKUng" v-if="xxbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="jjbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="tjbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.meterNumber"
            size="small"
          >
            <el-radio-button
              v-for="item in this.MSList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="fhgbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="hsDiv">
        <div class="dialog-div">
          <span class="title-span"
            >总&nbsp;&nbsp;&nbsp;环&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.totalNumber"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList1"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzCreatParams.meterNumber"
            size="small"
          >
            <el-radio-button
              v-for="item in this.MSList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="sbcsDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzCreatParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="jfDiv">
        <div class="dialog-div">
          <span class="title-span"
            >积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分:</span
          >
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.pointsOf"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="zsDiv">
        <div class="dialog-div">
          <span class="title-span">消 费 组 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzCreatParams.consumerGroups"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</span
        >
        <el-input
          size="small"
          class="title-select"
          style="width: 400px"
          v-model="xzCreatParams.remarks"
        ></el-input>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">勋 章 logo:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="creatHandleAvatarSuccess"
          :before-upload="creatBeforeAvatarUpload"
        >
          <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xzCreatDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createxzCommit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="创建勋章"
      :visible.sync="xzEditDialogVisible"
      width="770px"
      :close-on-click-modal="false"
    >
      <div class="dialog-div">
        <span class="title-span">勋 章 名 称:</span>
        <el-input
          size="small"
          class="title-select"
          v-model="xzEditParams.medalName"
        ></el-input>
      </div>
      <div class="dialog-div">
        <span class="title-span">勋 章 分 类:</span>
        <!--        <el-input size="small" class="title-select" v-model="xzCreatParams.competitionType"></el-input>-->
        <el-select
          v-model="xzEditParams.competitionType"
          size="small"
          class="title-select"
        >
          <el-option
            v-for="item in this.xzflList"
            :label="item.title"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-div">
        <span class="title-span">获 取 条 件:</span>
        <el-radio-group
          class="title-radio"
          v-model="xzEditParams.medalType"
          @change="ETtjChange"
          size="small"
        >
          <el-radio-button
            v-for="item in this.xztjList"
            :label="item.value"
            :key="item.value"
            >{{ item.text }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="tiaojianKUng" v-if="ETxxbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETjjbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETtjbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.meterNumber"
            size="small"
          >
            <el-radio-button
              v-for="item in this.MSList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETfhgbDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="EThsDiv">
        <div class="dialog-div">
          <span class="title-span"
            >总&nbsp;&nbsp;&nbsp;环&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.totalNumber"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >弓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;种:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.bowType"
            size="small"
          >
            <el-radio-button
              v-for="item in this.GZList1"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="dialog-div">
          <span class="title-span"
            >米&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</span
          >
          <el-radio-group
            class="title-radio"
            v-model="xzEditParams.meterNumber"
            size="small"
          >
            <el-radio-button
              v-for="item in this.MSList"
              :label="item.value"
              :key="item.value"
              >{{ item.text }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETsbcsDiv">
        <div class="dialog-div">
          <span class="title-span">上 榜 次 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.numberTimes"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
        <div class="dialog-div">
          <span class="title-span">名 次 排 行:</span>
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListStart"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
          至
          <el-input
            size="small"
            class="title-inp"
            v-model="xzEditParams.rankingListEnd"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETjfDiv">
        <div class="dialog-div">
          <span class="title-span"
            >积&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分:</span
          >
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.pointsOf"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="tiaojianKUng" v-if="ETzsDiv">
        <div class="dialog-div">
          <span class="title-span">消 费 组 数:</span>
          <el-input
            size="small"
            class="title-select"
            v-model="xzEditParams.consumerGroups"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          ></el-input>
        </div>
      </div>
      <div class="dialog-div">
        <span class="title-span"
          >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:</span
        >
        <el-input
          size="small"
          class="title-select"
          style="width: 400px"
          v-model="xzEditParams.remarks"
        ></el-input>
      </div>
      <div class="dialog-div clearfix">
        <span class="title-span" style="float: left">勋 章 logo:</span>
        <el-upload
          style="float: left"
          class="avatar-uploader"
          accept=".png,.jpg,.jpeg,.JPG,.JPEG"
          :headers="headers"
          :action="upLoadUrl"
          :show-file-list="false"
          :on-success="editHandleAvatarSuccess"
          :before-upload="editBeforeAvatarUpload"
        >
          <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xzEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editxzCommit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMedalListPage,
  getMedalById,
  addMedal,
  updateMedal,
  getAntMembersPage,
  competitionType,
  medalGetType,
} from "../../api/OperationManagement";
import { globelurl, posturl } from "../../api/axios.js";

export default {
  name: "9MedalManagement",
  data() {
    return {
      activeName: "nine",
      titleUrl: globelurl,
      xzParams: {
        createDateStart: "",
        createDateEnd: "",
        pageNo: 1,
        pageSize: 10,
      },
      xzResult: {},
      xzList: [],
      xzCreatDialogVisible: false,
      xzEditDialogVisible: false,
      xzCreatParams: {
        medalName: "",
        competitionType: "",
        medalType: "rookieList",
        remarks: "",
        logoPath: "",
        numberTimes: "",
        rankingListStart: "",
        rankingListEnd: "",
        bowType: "",
        meterNumber: "",
        totalNumber: "",
        pointsOf: "",
        consumerGroups: "",
      },
      xzEditParams: {
        id: "",
        medalName: "",
        competitionType: "",
        medalType: "",
        remarks: "",
        logoPath: "",
        numberTimes: "",
        rankingListStart: "",
        rankingListEnd: "",
        bowType: "",
        meterNumber: "",
        totalNumber: "",
        pointsOf: "",
        consumerGroups: "",
      },
      xzflList: [],
      xztjList: [],
      GZList: [
        {
          value: "0",
          text: "不限",
          title: "不限",
        },
        {
          value: "1",
          text: "反曲弓",
          title: "反曲弓",
        },
        {
          value: "2",
          text: "光弓",
          title: "光弓",
        },
      ],
      GZList1: [
        {
          value: "0",
          text: "不限",
          title: "不限",
        },
        {
          value: "1",
          text: "反曲弓",
          title: "反曲弓",
        },
        {
          value: "2",
          text: "光弓",
          title: "光弓",
        },
        {
          value: "3",
          text: "反曲弓",
          title: "反曲弓",
        },
      ],
      MSList: [
        {
          value: "0",
          text: "不限",
          title: "不限",
        },
        {
          value: "10",
          text: "10m",
          title: "10m",
        },
        {
          value: "18",
          text: "18m",
          title: "18m",
        },
      ],
      xxbDiv: true,
      jjbDiv: false,
      tjbDiv: false,
      fhgbDiv: false,
      hsDiv: false,
      sbcsDiv: false,
      jfDiv: false,
      zsDiv: false,
      ETxxbDiv: true,
      ETjjbDiv: false,
      ETtjbDiv: false,
      ETfhgbDiv: false,
      EThsDiv: false,
      ETsbcsDiv: false,
      ETjfDiv: false,
      ETzsDiv: false,
      headers: { "X-Access-Token": sessionStorage.token },
      upLoadUrl: posturl,
      creatImageUrl: "",
      editImageUrl: "",
    };
  },
  mounted() {
    this.getMedalListPage(this.xzParams);
    this.getCompetitionType();
    this.getMedalGetType();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        // this.$router.push('/OperationManagement/9MedalManagement');
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    //获取勋章列表
    getMedalListPage(params) {
      getMedalListPage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.xzResult = res.data.result;
            this.xzList = res.data.result.records;
          } else {
            this.xzResult = res.data.result;
            this.xzList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //分页改变
    xzSizeChange(newSize) {
      this.xzParams.pageSize = newSize;
      this.getMedalListPage(this.xzParams);
    },
    //分页改变
    xzCurrentChange(newPage) {
      this.xzParams.pageNo = newPage;
      this.getMedalListPage(this.xzParams);
    },
    //勋章开始时间改变
    xzStartChange(val) {
      if (
        this.xzParams.createDateStart &&
        this.xzParams.createDateEnd &&
        new Date(this.xzParams.createDateStart).getTime() >
          new Date(this.xzParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.xzParams.pageNo = 1;
      this.getMedalListPage(this.xzParams);
    },
    //勋章结束时间改变
    xzEndChange(val) {
      if (
        this.xzParams.createDateStart &&
        this.xzParams.createDateEnd &&
        new Date(this.xzParams.createDateStart).getTime() >
          new Date(this.xzParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.xzParams.pageNo = 1;
      this.getMedalListPage(this.xzParams);
    },
    // 获取勋章分类
    getCompetitionType() {
      competitionType().then((res) => {
        if (res.data.success) {
          this.xzflList = res.data.result;
        }
      });
    },
    // 获取勋章分类
    getMedalGetType() {
      medalGetType().then((res) => {
        if (res.data.success) {
          this.xztjList = res.data.result;
        }
      });
    },
    //创建勋章提交
    createxzCommit() {
      if (this.xzCreatParams.medalName == "") {
        this.$message.error("请输入勋章名称");
      } else if (this.xzCreatParams.competitionType == "") {
        this.$message.error("请选择勋章分类");
      } else if (this.xzCreatParams.medalType == "") {
        this.$message.error("请选择勋章获取条件");
      } else if (this.xzCreatParams.remarks == "") {
        this.$message.error("请输入勋章备注");
      } else if (this.xzCreatParams.logoPath == "") {
        this.$message.error("请上传勋章Logo");
      } else if (this.xzCreatParams.medalType == "rookieList") {
        if (this.xzCreatParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzCreatParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "classAList") {
        if (this.xzCreatParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzCreatParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "extraList") {
        if (this.xzCreatParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzCreatParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else if (this.xzCreatParams.meterNumber == "") {
          this.$message.error("请选择米数");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "compositeList") {
        if (this.xzCreatParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzCreatParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "cylinderNumber") {
        if (this.xzCreatParams.totalNumber == "") {
          this.$message.error("请输入总环数");
        } else if (this.xzCreatParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else if (this.xzCreatParams.meterNumber == "") {
          this.$message.error("请选择米数");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "numberOfTimes") {
        if (this.xzCreatParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzCreatParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzCreatParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "points") {
        if (this.xzCreatParams.pointsOf == "") {
          this.$message.error("请输入积分");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      } else if (this.xzCreatParams.medalType == "groupCount") {
        if (this.xzCreatParams.consumerGroups == "") {
          this.$message.error("请输入消费组数");
        } else {
          this.addMedal(this.xzCreatParams);
        }
      }
    },
    //创建勋章请求
    addMedal(params) {
      addMedal(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message.success("创建勋章成功");
          this.getMedalListPage(this.xzParams);
          this.xzCreatDialogVisible = false;
          this.xzCreatParams.numberTimes = "";
          this.xzCreatParams.rankingListStart = "";
          this.xzCreatParams.rankingListEnd = "";
          this.xzCreatParams.bowType = "";
          this.xzCreatParams.meterNumber = "";
          this.xzCreatParams.totalNumber = "";
          this.xzCreatParams.pointsOf = "";
          this.xzCreatParams.consumerGroups = "";
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //创建勋章类别切换
    tjChange(val) {
      if (val == "rookieList") {
        this.xxbDiv = true;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "classAList") {
        this.xxbDiv = false;
        this.jjbDiv = true;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "extraList") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = true;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "compositeList") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = true;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "cylinderNumber") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = true;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "numberOfTimes") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = true;
        this.jfDiv = false;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "points") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = true;
        this.zsDiv = false;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      } else if (val == "groupCount") {
        this.xxbDiv = false;
        this.jjbDiv = false;
        this.tjbDiv = false;
        this.fhgbDiv = false;
        this.hsDiv = false;
        this.sbcsDiv = false;
        this.jfDiv = false;
        this.zsDiv = true;
        this.xzCreatParams.numberTimes = "";
        this.xzCreatParams.rankingListStart = "";
        this.xzCreatParams.rankingListEnd = "";
        this.xzCreatParams.bowType = "";
        this.xzCreatParams.meterNumber = "";
        this.xzCreatParams.totalNumber = "";
        this.xzCreatParams.pointsOf = "";
        this.xzCreatParams.consumerGroups = "";
      }
    },
    //新建勋章图片上传
    creatHandleAvatarSuccess(res, file) {
      this.xzCreatParams.logoPath = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //编辑勋章获取勋章详细信息
    edutXZ(xzId) {
      //获取勋章详细信息
      console.log(xzId);
      getMedalById({ id: xzId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.xzEditDialogVisible = true;
          this.xzEditParams.id = res.data.result.id;
          this.xzEditParams.medalName = res.data.result.medalName;
          this.xzEditParams.competitionType = res.data.result.competitionType;
          this.xzEditParams.medalType = res.data.result.medalType;
          this.xzEditParams.remarks = res.data.result.remarks;
          this.editImageUrl = globelurl + res.data.result.logoPath;
          this.xzEditParams.logoPath = res.data.result.logoPath;
          this.xzEditParams.numberTimes = res.data.result.numberTimes;
          this.xzEditParams.rankingListStart = res.data.result.rankingListStart;
          this.xzEditParams.rankingListEnd = res.data.result.rankingListEnd;
          this.xzEditParams.bowType = res.data.result.bowType;
          this.xzEditParams.meterNumber = res.data.result.meterNumber;
          this.xzEditParams.totalNumber = res.data.result.totalNumber;
          this.xzEditParams.pointsOf = res.data.result.pointsOf;
          this.xzEditParams.consumerGroups = res.data.result.consumerGroups;
          if (res.data.result.medalType == "rookieList") {
            this.ETxxbDiv = true;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "classAList") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = true;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "extraList") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = true;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "compositeList") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = true;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "cylinderNumber") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = true;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "numberOfTimes") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = true;
            this.ETjfDiv = false;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "points") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = true;
            this.ETzsDiv = false;
          } else if (res.data.result.medalType == "groupCount") {
            this.ETxxbDiv = false;
            this.ETjjbDiv = false;
            this.ETtjbDiv = false;
            this.ETfhgbDiv = false;
            this.EThsDiv = false;
            this.ETsbcsDiv = false;
            this.ETjfDiv = false;
            this.ETzsDiv = true;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑勋章图片上传
    editHandleAvatarSuccess(res, file) {
      this.xzEditParams.logoPath = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },
    editBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //编辑勋章类别切换
    ETtjChange(val) {
      if (val == "rookieList") {
        this.ETxxbDiv = true;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "classAList") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = true;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "extraList") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = true;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "compositeList") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = true;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "cylinderNumber") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = true;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "numberOfTimes") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = true;
        this.ETjfDiv = false;
        this.ETzsDiv = false;
        this.xzEditParams.numberTimes = "";
        this.xzEditParams.rankingListStart = "";
        this.xzEditParams.rankingListEnd = "";
        this.xzEditParams.bowType = "";
        this.xzEditParams.meterNumber = "";
        this.xzEditParams.totalNumber = "";
        this.xzEditParams.pointsOf = "";
        this.xzEditParams.consumerGroups = "";
      } else if (val == "points") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = true;
        this.ETzsDiv = false;
        // this.xzEditParams.numberTimes = ''
        // this.xzEditParams.rankingListStart = ''
        // this.xzEditParams.rankingListEnd = ''
        // this.xzEditParams.bowType = ''
        // this.xzEditParams.meterNumber = ''
        // this.xzEditParams.totalNumber = ''
        // this.xzEditParams.pointsOf = ''
        // this.xzEditParams.consumerGroups = ''
      } else if (val == "groupCount") {
        this.ETxxbDiv = false;
        this.ETjjbDiv = false;
        this.ETtjbDiv = false;
        this.ETfhgbDiv = false;
        this.EThsDiv = false;
        this.ETsbcsDiv = false;
        this.ETjfDiv = false;
        this.ETzsDiv = true;
        // this.xzEditParams.numberTimes = ''
        // this.xzEditParams.rankingListStart = ''
        // this.xzEditParams.rankingListEnd = ''
        // this.xzEditParams.bowType = ''
        // this.xzEditParams.meterNumber = ''
        // this.xzEditParams.totalNumber = ''
        // this.xzEditParams.pointsOf = ''
        // this.xzEditParams.consumerGroups = ''
      }
    },
    //编辑勋章提交
    editxzCommit() {
      if (this.xzEditParams.medalName === "") {
        this.$message.error("请输入勋章名称");
      } else if (this.xzEditParams.competitionType === "") {
        this.$message.error("请选择勋章分类");
      } else if (this.xzEditParams.medalType === "") {
        this.$message.error("请选择勋章获取条件");
      } else if (this.xzEditParams.remarks === "") {
        this.$message.error("请输入勋章备注");
      } else if (this.xzEditParams.logoPath === "") {
        this.$message.error("请上传勋章Logo");
      } else if (this.xzEditParams.medalType == "rookieList") {
        if (this.xzEditParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzEditParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "classAList") {
        if (this.xzEditParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzEditParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "extraList") {
        if (this.xzEditParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzEditParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else if (this.xzEditParams.meterNumber == "") {
          this.$message.error("请选择米数");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "compositeList") {
        if (this.xzEditParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzEditParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "cylinderNumber") {
        if (this.xzEditParams.totalNumber == "") {
          this.$message.error("请输入总环数");
        } else if (this.xzEditParams.bowType == "") {
          this.$message.error("请选择弓种");
        } else if (this.xzEditParams.meterNumber == "") {
          this.$message.error("请选择米数");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "numberOfTimes") {
        if (this.xzEditParams.numberTimes == "") {
          this.$message.error("请输入上榜次数");
        } else if (this.xzEditParams.rankingListStart == "") {
          this.$message.error("请输入名次排行");
        } else if (this.xzEditParams.rankingListEnd == "") {
          this.$message.error("请输入名次排行");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "points") {
        if (this.xzEditParams.pointsOf == "") {
          this.$message.error("请输入积分");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      } else if (this.xzEditParams.medalType == "groupCount") {
        if (this.xzEditParams.consumerGroups == "") {
          this.$message.error("请输入消费组数");
        } else {
          this.updateMedal(this.xzEditParams);
        }
      }
    },
    updateMedal(params) {
      updateMedal(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.$message.success("编辑勋章成功");
          this.getMedalListPage(this.xzParams);
          this.xzEditDialogVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-inp {
  margin: 0 20px;
  width: 100px;
}

.title-radio {
  margin: 0 20px;
  width: 600px;
  display: inline;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.dialog-div {
  margin: 20px 0;
}

.tiaojianKUng {
  margin-left: 100px;
}
</style>

<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
